// @ts-ignore
import axios from "axios";
import jwt_decode from "jwt-decode"
import { AxiosResponse } from "axios";

import createAuthRefreshInterceptor from "axios-auth-refresh";
import { router } from "./main";
import Action from "./store/actionTypes";
import store from "./store"

const BASE_URL = "https://dev.statementsapi.retailinformationservices.com/";
// const BASE_URL = "http://0.0.0.0:5000/";
// Function that will be called to refresh authorization
const refreshAuthLogic = (failedRequest: any) => {
  return axios.post(`${BASE_URL}auth/refresh`,
    {}, { headers: { Authorization: `Bearer ${localStorage.getItem("refresh_token")}` } })
    .then((tokenRefreshResponse: any) => {
      localStorage.setItem("access_token", tokenRefreshResponse.data.access_token);
    }, (error) => {
      router.push({
        path: "login"
      });
    });
}

// Instantiate the interceptor (you can chain it as it returns the axios instance)
createAuthRefreshInterceptor(axios, refreshAuthLogic);

export default class Client {
  static get jwt_valid() {
    console.log("chasdfecking...");
    const refreshToken = localStorage.getItem("refresh_token") || "";
    try {
      let exp: number = jwt_decode(refreshToken);
      if (exp < (new Date().getTime() + 1) / 1000) {
        store.dispatch(Action.LOGOUT).finally(() => {
          router.push({
            path: "login"
          });
        });
        return false;
      }
    } catch (err) {
      return false;
    }
    return true;
  }
  static get auth_headers() {
    return {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`
    };
  }

  static get<T>(url: string, params?: object): Promise<AxiosResponse<T>> {
    return axios.get<T>(`${BASE_URL}${url}`, { params, headers: Client.auth_headers })
      .then((response) => {
        return response;
      }, (e) => {
        return refreshAuthLogic(undefined).then(() => {
          return axios.get<T>(`${BASE_URL}${url}`, { params, headers: Client.auth_headers });
        });
      });
  }

  static post<T>(url: string, params: object): Promise<AxiosResponse<T>> {
    return axios.post<T>(`${BASE_URL}${url}`, { ...params }, { headers: Client.auth_headers })
      .then((response) => {
        return response;
      }, (e) => {
        return refreshAuthLogic(undefined).then(() => {
          return axios.post<T>(`${BASE_URL}${url}`, { ...params }, { headers: Client.auth_headers });
        });
      });
  }

  static put<T>(url: string, params: object): Promise<AxiosResponse<T>> {
    return axios.put<T>(`${BASE_URL}${url}`, { ...params }, { headers: Client.auth_headers })
      .then((response) => {
        return response;
      }, (e) => {
        return refreshAuthLogic(undefined).then(() => {
          return axios.put<T>(`${BASE_URL}${url}`, { ...params }, { headers: Client.auth_headers });
        });
      });
  }

  static async postSaveCredentials<T>(url: string, params: object): Promise<AxiosResponse<T>> {
    const response: any = await Client.post(url, params);
    localStorage.setItem("access_token", response.data.access_token);
    localStorage.setItem("refresh_token", response.data.refresh_token);
    return response;
  }
}
